var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#FF5722",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.25H12.65C11.8099 22.25 11.3899 22.25 11.069 22.0865C10.7868 21.9427 10.5573 21.7132 10.4135 21.431C10.25 21.1102 10.25 20.6901 10.25 19.85V14.15C10.25 13.3099 10.25 12.8899 10.4135 12.569C10.5573 12.2868 10.7868 12.0573 11.069 11.9135C11.3899 11.75 11.8099 11.75 12.65 11.75H21.35C22.1901 11.75 22.6101 11.75 22.931 11.9135C23.2132 12.0573 23.4427 12.2868 23.5865 12.569C23.75 12.8899 23.75 13.3099 23.75 14.15V14.375M18.5 15.5H20.75M18.5 23L20.0187 22.6962C20.1511 22.6698 20.2173 22.6565 20.2791 22.6323C20.3339 22.6108 20.386 22.5829 20.4342 22.5492C20.4887 22.5113 20.5364 22.4636 20.6319 22.368L23.75 19.25C24.1642 18.8358 24.1642 18.1642 23.75 17.75C23.3358 17.3358 22.6642 17.3358 22.25 17.75L19.1319 20.868C19.0364 20.9636 18.9887 21.0113 18.9507 21.0657C18.9171 21.114 18.8892 21.1661 18.8677 21.2209C18.8435 21.2826 18.8302 21.3489 18.8037 21.4812L18.5 23Z",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2857 18.1668C12.2857 18.8135 12.7857 19.3335 13.399 19.3335H14.6524C15.1857 19.3335 15.619 18.8801 15.619 18.3135C15.619 17.7068 15.3524 17.4868 14.959 17.3468L12.9524 16.6468C12.559 16.5068 12.2924 16.2935 12.2924 15.6801C12.2924 15.1202 12.7257 14.6602 13.259 14.6602H14.5124C15.1257 14.6602 15.6257 15.1802 15.6257 15.8268",
    stroke: "#F45600",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9524 14V20",
    stroke: "#F45600",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryStructure);
export default __webpack_public_path__ + "static/media/SalaryStructure.4f415bdb770d07b08a27ea57b4777a81.svg";
export { ForwardRef as ReactComponent };